import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';
import DeleteIcon from '@mui/icons-material/Delete';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import EditIcon from '@mui/icons-material/Edit';
import { IconButton, Tooltip } from '@mui/material';
import Button from '@mui/material/Button';
import React from 'react';
import styles from "../styles/components/delete-confirmation.module.scss";

interface DeleteConfirmationProps {
  onDelete: () => void
  onCancel?: () => void
  onActive?: () => void
  size?: 'small' | 'medium' | 'large'
  title?: string
  showButton?: boolean
}

export const DeleteConfirmation = ({
  onDelete,
  onCancel,
  onActive,
  size = 'medium',
  title = "Delete",
  showButton = false,
}: DeleteConfirmationProps) => {
  const [deleteActive, setDeleteActive] = React.useState(false)

  return (
    <>
      {!deleteActive ?
          <Tooltip
            title={title} 
            placement="bottom" 
            arrow
          >
            <span>
              {showButton ?
                <Button 
                  size={size}
                  color='error'
                  startIcon={<DeleteIcon />}
                  onClick={async () => {
                    setDeleteActive(true)
                      if (onActive) {
                        onActive()
                      }
                  }}>
                  {title}
                </Button>
                :
                  <IconButton 
                    size={size}
                    onClick={() => {
                      setDeleteActive(true)
                      if (onActive) {
                        onActive()
                      }
                    }
                  }>
                    <DeleteIcon />
                  </IconButton>
                }
            </span>
          </Tooltip>
        :
        <div className={styles.buttonRow}>
          <Button 
            size={size}
            color='error'
            startIcon={<DeleteForeverIcon />}
            onClick={async () => {
              onDelete()
            }}>
            Remove
          </Button>
          <Button 
            size={size}
            color="info"
            onClick={() => {
              setDeleteActive(false)
              if (onCancel) {
                onCancel()
              }
            }}>
            Keep
          </Button>
        </div>
      }
    </>
  )
}

interface EditSaveConfirmationProps {
  onSave: () => void
  onCancel: () => void
  onActive: () => void
  size?: 'small' | 'medium' | 'large'
  title?: string
  showButton?: boolean
}

export const EditSaveConfirmation = ({
  onSave,
  onCancel,
  onActive,
  size = 'medium',
  title = "Edit",
  showButton = false,
}: EditSaveConfirmationProps) => {
  const [editActive, setEditActive] = React.useState(false)

  return (
    <>
      {
        !editActive ?
          <Tooltip
            title={title} 
            placement="bottom" 
            arrow
          >
            <span>
              <IconButton 
                size={size}
                onClick={() => {
                  setEditActive(true)
                  if (onActive) {
                    onActive()
                  }
                }
              }>
                <EditIcon />
              </IconButton>
              {/* {showButton ?
                <Button 
                  size={size}
                  color='success'
                  startIcon={<EditIcon />}
                  onClick={async () => {
                    setEditActive(true)
                    if (onActive) {
                      onActive()
                    }
                  }}>
                  {title}
                </Button>
                :
                  <IconButton 
                    size={size}
                    onClick={() => {
                      setEditActive(true)
                      if (onActive) {
                        onActive()
                      }
                    }
                  }>
                    <EditIcon />
                  </IconButton>
                } */}
            </span>
          </Tooltip>
        :
        <div>
          {!showButton ?
            <>
              <IconButton
                size="small"
                color="success"
                onClick={(e: React.SyntheticEvent) => {
                  e.preventDefault()
                  setEditActive(false)
                  onSave()
                  
                }}
              >
                <CheckIcon />
              </IconButton>
              <IconButton
                size="small"
                color="warning"
                onClick={(e: React.SyntheticEvent) => {
                  e.preventDefault()
                  setEditActive(false)
                  onCancel()
                }}
              >
                <CloseIcon />
              </IconButton>
            </>
            :
            <>
              <Button 
                size={size}
                color='success'
                startIcon={<CheckIcon />}
                onClick={async () => {
                  setEditActive(false)
                  onSave()
                }}>
                Save
              </Button>
              <Button 
                size={size}
                color="info"
                startIcon={<CloseIcon />}
                onClick={() => {
                  setEditActive(false)
                  onCancel()
                }}>
                Cancel
              </Button>
            </>
          }
        </div>
      }
    </>
  )
}
